module.exports = __webpack_public_path__ + "img/big_love.1fe4e771.png";